































import Vue from 'vue'
import AuthorInput from '@/components/AuthorInput.vue'
import UiCard from '@/components/UiCard.vue'
import UiSkeleton from '@/components/UiSkeleton.vue'
import UiButton from '@/components/UiButton.vue'
import { db } from '@/services/firebaseAdapter'

export default Vue.extend({
  name: "PostEdit",
  computed: {},
  data(){
    return {
      organizationId: this.$route.params.organizationId,
      postId: this.$route.params.postId,
      initialPostDraft: null
    }
  },
  async created(){
    try {
      // LOAD Post draft
      const postDraft = await db.getPost(this.organizationId, this.postId)
      if(!postDraft || postDraft == null) throw("No post draft")
      // @ts-ignore
      this.initialPostDraft = await db.getPost(this.$route.params.organizationId, this.$route.params.postId)
    } catch (error) {
      console.error("ERROR loading post to edit", error)
      this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.organizationId }})
    }
  },
  methods: {
    handleUpdateSubmit(){
      // TODO: Add success message
      this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.organizationId }})
    },
    handleCancelClick(){
      this.$router.push({ name: 'OrganizationFeed', params: { organizationId: this.organizationId }})
    }
  },
  components: {
    AuthorInput,
    UiCard,
    UiSkeleton,
    UiButton
  }
})
